import { render, staticRenderFns } from "./InitiativesFlow.vue?vue&type=template&id=1ddc446e"
import script from "./InitiativesFlow.vue?vue&type=script&lang=ts"
export * from "./InitiativesFlow.vue?vue&type=script&lang=ts"
import style0 from "./InitiativesFlow.vue?vue&type=style&index=0&id=1ddc446e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports